import { Outlet, createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { useTranslation } from "react-i18next";

import useDocumentTitle from "@/hooks/useDocumentTitle";
import { defaultNS } from "@/lib/i18n";

import { getSoftwareAlertCounts } from "./-query/api";
import { SearchSchema } from "./-zod-schema";

export const Route = createFileRoute("/_staff/software/_layout/alerts/_alerts")(
  {
    validateSearch: zodValidator(SearchSchema),
    component: SoftwareAlerts,
    loader: getSoftwareAlertCounts,
  },
);

function SoftwareAlerts() {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "pages.software.alert",
  });
  useDocumentTitle(t("pageTitle"));

  return <Outlet />;
}
